<script setup>
import { computed } from 'vue';
import { format } from 'date-fns';

// Where a visit request stands, from the request to the visit it was scheduled into: requested,
// scheduled for a date, done.
const props = defineProps({
  // The request, carrying its current visit.
  task: { type: Object, required: true },
});

const formatDate = value => (value ? format(new Date(value), 'dd/MM HH:mm') : '');

const steps = computed(() => {
  const { visit } = props.task;
  const isVisited = visit?.status === 'done';
  return [
    { key: 'REQUESTED', isReached: true, date: props.task.created_at },
    { key: 'SCHEDULED', isReached: !!visit, date: visit?.due_at },
    { key: 'VISITED', isReached: isVisited, date: isVisited && visit.done_at },
  ];
});
</script>

<template>
  <ol class="flex items-start gap-2 mb-0 list-none ltr:pl-0 rtl:pr-0">
    <li
      v-for="(step, index) in steps"
      :key="step.key"
      class="flex items-start flex-1 min-w-0 gap-2"
      :data-visit-step="step.key"
      :data-reached="step.isReached"
    >
      <span
        class="mt-1 rounded-full size-2.5 shrink-0"
        :class="step.isReached ? 'bg-n-teal-9' : 'bg-n-slate-6'"
      />
      <span class="flex flex-col min-w-0">
        <span
          class="text-xs font-medium"
          :class="step.isReached ? 'text-n-slate-12' : 'text-n-slate-10'"
        >
          {{ $t(`CARDS.VISIT.STEPS.${step.key}`) }}
        </span>
        <span v-if="step.date" class="text-xs text-n-slate-10">
          {{ formatDate(step.date) }}
        </span>
      </span>
      <span
        v-if="index < steps.length - 1"
        class="flex-1 h-px mt-2 bg-n-weak"
      />
    </li>
  </ol>
</template>
